export const getSessionToken = function() {
    let params = new URL(document.location.href).searchParams;
    return params.get("sessionToken"); 
};

export const isDocs = function() {
    let params = new URL(document.location.href).searchParams;
    return (params.get("docs") == "true"); 
};
